const bookDemoSteps = {
  steps: [
    {
      id: 0,
      type: 'welcome',
      title: "Hello! I'm the Ogiso Assistant",
      subtitle: "I'll ask a few quick questions to tailor your demo. This takes just a minute.",
      buttonLabel: "Let's start",
      image: '/assets/website/onboarding/hello.png',
    },
    {
      id: 1,
      type: 'input',
      field: 'name',
      title: 'To get started, can I have your name please?',
      placeholder: 'Type your name...',
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/contact.png',
    },
    {
      id: 2,
      type: 'inputs',
      title: 'Thanks, {name}!',
      subtitle: "What's the best email and phone number to reach you? (We'll only use it to confirm details).",
      fields: [
        { name: 'email', placeholder: 'Email address' },
        { name: 'phone', placeholder: 'Phone Number' },
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/contact.png',
    },
    {
      id: 4,
      type: 'options',
      field: 'serviceTypes',
      title: 'Great! What type of services does your organization provide?',
      subtitle: 'Select one or more options.',
      multiSelect: true,
      options: [
        'IDD Services',
        'Mental Health',
        'Home Health / Personal Care',
        'Assisted Living',
        'Not yet operational',
        'Other',
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/services.png',
    },
    {
      id: 5,
      type: 'options',
      field: 'settings',
      title: 'Perfect! In what settings do you provide your services?',
      subtitle: 'Select one or more options.',
      multiSelect: true,
      options: [
        'Group Home',
        'Day Support/ Day Program',
        'Supportive In-Home',
        'Supported Living',
        'Community Engagement',
        'Not yet operational',
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/other-2.png',
    },
    {
      id: 6,
      type: 'dropdown_multi',
      field: 'states',
      title: 'Got it! Which state(s) does your organization currently operate in?',
      options: [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
        'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
        'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
        'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
        'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
        'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
        'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
        'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
        'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
        'District of Columbia', 'Other',
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/location.png',
    },
    {
      id: 7,
      type: 'options',
      field: 'recordingMethod',
      title: 'How do you currently record client notes, medication logs, and daily tasks?',
      options: [
        'We do not record yet',
        'On paper',
        'Spreadsheets / Word',
        'Another software (please specify)',
      ],
      skipIf: { field: 'settings', includes: 'Not yet operational' },
      image: '/assets/website/onboarding/other-3.png',
    },
    {
      id: 8,
      type: 'input',
      field: 'currentSoftware',
      title: 'Got it — which system are you currently using?',
      placeholder: 'e.g. Therap, PointClickCare...',
      condition: {
        field: 'recordingMethod',
        value: 'Another software (please specify)',
      },
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/other-3.png',
    },
    {
      id: 9,
      type: 'options',
      field: 'timeline',
      title: 'How soon are you looking to implement an EHR platform?',
      options: [
        'Immediately (within 1-2 weeks)',
        'In the next 1–2 months',
        'In 3–6 months',
        'Just exploring options right now',
      ],
      skipIf: { field: 'settings', includes: 'Not yet operational' },
      image: '/assets/website/onboarding/tools.png',
    },
    {
      id: 10,
      type: 'options',
      field: 'staffCount',
      title: 'Roughly how many staff members are on your team?',
      dynamicTitle: {
        dependency: 'timeline',
        cases: {
          'Immediately (within 1-2 weeks)':
            'Perfect — we can get you set up right away. Roughly how many staff members are on your team?',
          'In the next 1–2 months':
            'Perfect — we can get you set up right away. Roughly how many staff members are on your team?',
          default:
            "No problem! We'll provide info for when you're ready. Roughly how many staff members are on your team?",
        },
      },
      options: ['1-5 Staffs', '6-10 Staffs', '11-50 Staffs', '51+ Staffs'],
      image: '/assets/website/onboarding/staff.png',
    },
    {
      id: 11,
      type: 'options',
      field: 'clientCount',
      title: 'And how many clients or residents do you currently serve?',
      options: ['1-5 Clients', '6-10 Clients', '11-50 Clients', '51+ Clients'],
      image: '/assets/website/onboarding/staff.png',
    },
    {
      id: 12,
      type: 'options',
      field: 'frustrations',
      title: "What's the biggest frustration with your current process?",
      subtitle: 'Select one or more.',
      multiSelect: true,
      options: [
        'Missed documentation',
        'Hard to find or report information',
        'Too time-consuming',
        'Hard for staff to use',
        'Other',
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/question.png',
    },
    {
      id: 13,
      type: 'options',
      field: 'priorities',
      title: "When choosing an EHR system, what's most important to you?",
      subtitle: 'Select one or more.',
      multiSelect: true,
      options: [
        'Ease of use for staff',
        'Cost and affordability',
        'Compliance and reporting',
        'Customer support',
        'Integration with tools',
      ],
      buttonLabel: 'Continue',
      image: '/assets/website/onboarding/solution.png',
    },
    {
      id: 14,
      type: 'success',
      title: 'Thanks so much for sharing that!',
      dynamicTitle: {
        dependency: 'priorities',
        contains: {
          Cost: "Totally understandable — we can share pricing options that fit your budget.",
          Ease: "Excellent — we'll make sure to highlight how Ogiso simplifies documentation.",
        },
      },
      subtitle: 'Our team will review your info and reach out shortly to schedule your personalized demo.',
      image: '/assets/website/onboarding/hello.png',
    },
  ],
};

export default bookDemoSteps;
